import { Route, Routes } from 'react-router-dom';
import LandingPage from './landing';
import PrivateRouteProvider from '../providers/PrivateRouteProvider';
import Properties from './properties';
import LeaseDetail from './LeaseDetail';
import Layout from '../components/Layout';
import Reports from './Reports';
import DepositAssessment from './DepositAssessment';
import MoveInSurveys from './MoveInSurveys';
import ApplicationDetail from './ApplicationDetail';
import Banners from './Banners';
import PropertyCatalog from './PropertyCatalog';

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/" element={<PrivateRouteProvider />}>
        <Route
          path="/dashboard"
          element={
            <Layout>
              <Properties />
            </Layout>
          }
        />
        <Route
          path="/lease/:id"
          element={
            <Layout>
              <LeaseDetail />
            </Layout>
          }
        />
        <Route
          path="/banners"
          element={
            <Layout>
              <Banners />
            </Layout>
          }
        />
        <Route
          path="/properties"
          element={
            <Layout>
              <PropertyCatalog />
            </Layout>
          }
        />
        <Route
          path="/reports/deposit-assessment"
          element={
            <Layout fullWidth>
              <DepositAssessment />
            </Layout>
          }
        />
        <Route
          path="/reports"
          element={
            <Layout>
              <Reports />
            </Layout>
          }
        />
        <Route
          path="/move-in-surveys"
          element={
            <Layout>
              <MoveInSurveys />
            </Layout>
          }
        />
        <Route
          path="/applications/:id"
          element={
            <Layout>
              <ApplicationDetail />
            </Layout>
          }
        />
      </Route>
    </Routes>
  );
};
